import React, { useCallback } from 'react'
import { OrganizationEventType } from 'scenes/Dashboard/data/organizationEvents/types'
import { getFormFormattedDate, getToday } from 'utils'
import { insertItem, removeItemByIndex } from 'utils-next/arrays'
import { connect, FormProps } from 'utils-next/forms'

import { Typography } from '@mui/material'

import AddItemButton from '../../../../../AddItemButton'
import { OrganizationFormValues } from '../../OrganizationDetailsEdit.models'
import { useStyles } from '../FormSection.styles'
import OrganizationEventsEdit from './OrganizationEventEdit.component'
import { getOptionFromOrganizationEventType } from './OrganizationEventEdit.models'

type OrganizationEventsEditListProps = { formik: FormProps<OrganizationFormValues> }

const OrganizationEventsEditList = React.memo(
  ({
    formik: {
      setFieldValue,
      values: { organizationEventsValues },
    },
  }: OrganizationEventsEditListProps) => {
    const { classes } = useStyles()

    const onAddOrganizationEventClick = useCallback(
      () =>
        setFieldValue(
          'organizationEventsValues',
          insertItem(organizationEventsValues, buildOrganizationEvent(OrganizationEventType.contactAttempt))
        ),
      [organizationEventsValues, setFieldValue]
    )

    const handleDelete = useCallback(
      (index: number) => setFieldValue('organizationEventsValues', removeItemByIndex(organizationEventsValues, index)),
      [organizationEventsValues, setFieldValue]
    )

    return (
      <div className={classes.sectionContainer}>
        <Typography variant="h6">Events</Typography>
        {organizationEventsValues.map((organizationEventValue, index) => (
          <OrganizationEventsEdit
            key={organizationEventValue.id}
            className={classes.sectionItem}
            index={index}
            name="organizationEventsValues"
            organizationEventValue={organizationEventValue}
            onClickDelete={() => handleDelete(index)}
          />
        ))}
        <AddItemButton label="Add Contact Attempt" onClick={onAddOrganizationEventClick}>
          Add Organization Event
        </AddItemButton>
      </div>
    )
  }
)

OrganizationEventsEditList.displayName = 'OrganizationEventList'

export const buildOrganizationEvent = (type: string | null = null) => ({
  id: undefined,
  type: type ? getOptionFromOrganizationEventType(type) : null,
  happenedOn: getFormFormattedDate(getToday()),
})

export default connect<Record<string, unknown>, OrganizationFormValues>(OrganizationEventsEditList)
